<template>
  <div class="warp warp_enterprise" v-if="data">
    <Head></Head>
    <div class="modle_1" :style="'background: url('+data.img2+') center no-repeat; background-size: cover;'">
      <div class="txt_box">
        <div class="t1">

          {{data.encatname}}
        </div>
        <div class="t2">
          {{data.catname}}
        </div>
        <div class="t3">

          {{data.seodescription}}
        </div>
      </div>
      <ChildBan></ChildBan>
    </div>



    <div class="modle_9">

      <div class="tit" v-scroll-reveal.reset>
        我们服务于各类品牌，项目类型多元，行业涵盖与全类目<br>
        使品牌广告与效果广告紧密联系融合
      </div>

      <div class="group">

        <el-row :gutter="20">
          <el-col :xs="8" :sm="6" :md="4" v-scroll-reveal.reset :lg="3" v-for="(item,index) in data.list" :key="index">
            <div class="grid-content">

              <img :src="item.img1" />

            </div>
          </el-col>

        </el-row>


      </div>


    </div>


  </div>
</template>

<script>
  import {
    postClientsAPI
  } from '../../../api/api.js'
  import Head from '@/components/Head.vue'
  import ChildBan from '@/components/ChildBan.vue'

  export default {
    components: {
      Head,
      ChildBan
    },
    data() {
      return {

        data: null, //数据


      }
    },
    methods: {
      //获取服务品牌
      getList() {
        var that = this;
        postClientsAPI().then(function(res) {
          console.log(res);
          that.data = res.data.data;
        }).catch(function(err) {
          console.log(err);
        })
      },
    },
    mounted() {
      this.getList();
    }

  }
</script>

<style lang="less" scoped>
  // 引入公共css3
  @import '../../assets/css3.css';

  template {
    min-height: 100%;
  }

  html,
  body {
    position: relative;
    min-height: 100%;
    overflow-x: hidden;
    width: 100%;
  }

  .modle_1 {
    height: 1200px;
    width: 100%;
    background: #f5f5f5;
    position: relative;

    .txt_box {
      position: relative;
      top: 500px;
      padding: 0px 50px;
      text-align: left;

      .t1 {
        color: #fff;
        font-size: 138px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .t2 {
        color: #fff;
        font-size: 80px;
      }

      .t3 {
        color: #fff;
        opacity: 0.5;
        margin-top: 115px;
        font-size: 37px;
      }
    }
  }

  .modle_9 {
    margin-top: 150px;

    .tit {
      text-align: center;
      color: #000000;
      font-size: 50px;
      font-weight: bold;
      margin-bottom: 150px;
    }

    .group {
      margin: 0px 100px;

      .grid-content {
        height: 100px;
        margin-bottom: 70px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/servingcustomers/servingcustomers.vue